<template>
  <!-- Topbar Start -->
  <div class="navbar-custom">
    <ul class="list-unstyled topnav-menu float-right mb-0">


      <b-nav-item-dropdown right class="notification-list">

        <b-dropdown-text href="#" class="dropdown-item noti-title">
          <h5 class="m-0">
            <span class="float-right">
              <a href class="text-dark">
                <small>Clear All</small>
              </a>
            </span>Notification
          </h5>
        </b-dropdown-text>

        <b-dropdown-text href="#" class="p-0">
          <VuePerfectScrollbar v-once class="noti-scroll">



            <!-- item-->
            <a href="javascript:void(0);" class="dropdown-item notify-item">
              <div class="notify-icon bg-secondary">
                <i class="mdi mdi-comment-account-outline"></i>
              </div>
              <p class="notify-details">
                QC has reported some error in system.
                <b>Admin</b>
                <small class="text-muted">2 days ago</small>
              </p>
            </a>
          </VuePerfectScrollbar>

          <a
            href="javascript:void(0);"
            class="dropdown-item text-center text-primary notify-item notify-all"
          >
            View all
            <i class="fi-arrow-right"></i>
          </a>
        </b-dropdown-text>
      </b-nav-item-dropdown>

      <b-nav-item-dropdown right class="notification-list" menu-class="profile-dropdown">
        <template slot="button-content">
          <div class="nav-user mr-0">
            <img src="@assets/images/users/admin.png" alt="user-image" class="rounded-circle" />
            <span class="pro-user-name ml-1">
              {{user ? user.name : ''}}
              <i class="mdi mdi-chevron-down"></i>
            </span>
          </div>
        </template>

        <b-dropdown-item href="#">
          <i class="fe-user mr-1"></i>
          <span>Profile</span>
        </b-dropdown-item>

        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item href="/logout">
          <i class="fe-log-out mr-1"></i>
          <span>Logout</span>
        </b-dropdown-item>

      </b-nav-item-dropdown>

      <li class="dropdown notification-list">
        <button
          class="btn btn-link nav-link right-bar-toggle toggle-right"
          @click="toggleRightSidebar"
        >
          <i class="fe-list noti-icon toggle-right"></i>
        </button>
      </li>
    </ul>

    <!-- LOGO -->
    <div class="logo-box">
      <a href="index.html" class="logo text-center">
        <span class="logo-lg">
          <img src="@assets/images/logo-light.png" alt height="40" />
          <!-- <span class="logo-lg-text-light">Xeria</span> -->
        </span>
        <span class="logo-sm">
          <!-- <span class="logo-sm-text-dark">X</span> -->
          <img src="@assets/images/logo-sm.png" alt height="24" />
        </span>
      </a>
    </div>

    <ul class="list-unstyled topnav-menu topnav-menu-left m-0">
      <li>
        <button class="button-menu-mobile" @click="toggleMenu">
          <i class="fe-menu"></i>
        </button>
      </li>

    </ul>
  </div>
  <!-- end Topbar -->
</template>

<style lang="scss">
.noti-scroll {
  height: 220px;
}
.ps > .ps__scrollbar-y-rail {
  width: 8px !important;
  background-color: transparent !important;
}
.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
  width: 6px !important;
}
.button-menu-mobile {
  outline: none !important;
}
</style>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'

  import { authComputed } from '@state/helpers'

  export default {
    components: { VuePerfectScrollbar },
    props: {
      user: {
        type: Object,
        required: false,
        default: () => ({}),
      },
    },
    data() {
      return {}
    },
    computed: {
      ...authComputed,
    },
    async mounted(){

    },
    methods: {
      toggleMenu() {
        this.$parent.toggleMenu()
      },
      toggleRightSidebar() {
        this.$parent.toggleRightSidebar()
      },
    },
  }
</script>
